import React, { useEffect, useRef } from 'react';
import { FiX } from 'react-icons/fi';
import Nav from './Nav';

const MobileMenu = ({ show, onClose }) => {
    const closeButtonRef = useRef(null);

    useEffect(() => {
        if (!show) return undefined;

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        closeButtonRef.current?.focus();

        const handleKeyDown = (event) => {
            if (event.key === 'Escape') onClose();
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.body.style.overflow = previousOverflow;
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [show, onClose]);

    return (
        <div
            className={`popup-mobile-menu ${show ? 'active' : ''}`}
            aria-hidden={!show}
            role="dialog"
            aria-modal="true"
            aria-label="Menu nawigacyjne"
            onMouseDown={(event) => {
                if (event.target === event.currentTarget) onClose();
            }}
        >
            <div className="inner">
                <div className="header-top">
                    <strong className="mobile-menu-title">BlackWave</strong>
                    <div className="close-menu">
                        <button ref={closeButtonRef} type="button" className="close-button" onClick={onClose} aria-label="Zamknij menu">
                            <FiX />
                        </button>
                    </div>
                </div>
                <Nav onClose={onClose} />
                <a className="mobile-menu-call" href="tel:+48668650693" onClick={onClose}>+48 668 650 693</a>
            </div>
        </div>
    );
};

export default MobileMenu;
